lowerProto